export default __webpack_public_path__ + "static/media/product-marketing-school.7a900a26.webp";